import { useState } from "react";
import { TooltipProps } from '@mui/material';
import CopyToClipboard from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import GlobalTooltip from "../tooltip/globalTooltip";

type CopyToClipboardIconProps = {
    text: string;
    label: string;
    className?: string;
    iconClassName?: string;
    copiedTitle?: string;
    resetMs?: number;
    placement?: TooltipProps["placement"], 
    arrow?: boolean;
    tooltipTitle?: string;
};

const CopyToClipboardIcon = ({
    text,
    label,
    className,
    iconClassName,
    copiedTitle = "Copied!",
    resetMs = 2000,
    placement = "top",
    arrow = true,
    tooltipTitle = `Copy ${label}`,
}: CopyToClipboardIconProps) => {
    
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), resetMs);
    };

    return (
        <GlobalTooltip 
            title={copied ? copiedTitle : tooltipTitle} 
            placement={placement} 
            arrow={arrow}
        >
            <span
                className={className}
                onClick={(e) => e.stopPropagation()}
            >
                <CopyToClipboard text={text} onCopy={handleCopy}>
                    <ContentCopyIcon className={iconClassName} />
                </CopyToClipboard>
            </span>
        </GlobalTooltip>
    );
};

export default CopyToClipboardIcon;
